module.exports = __webpack_public_path__ + "img/icon-taken-by-recipient-en.062ce993.svg";